import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress CRA dev overlay for the recoverable React concurrent-rendering warning
// triggered by react-quill-new initialization. The page works correctly.
if (typeof window !== "undefined") {
    const _origError = window.console.error;
    window.console.error = (...args) => {
        const msg = args?.[0];
        if (typeof msg === "string" && msg.includes("error during concurrent rendering but React was able to recover")) {
            return;
        }
        _origError(...args);
    };
    window.addEventListener("error", (e) => {
        if (e.message && e.message.includes("error during concurrent rendering but React was able to recover")) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
